import React from "react";
import {
  Bar,
  Icon,
  IconsWrapper,
  Logo,
  LogoWrapper,
  Text,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
  SearchOutlined,
  DownloadOutlined,
  ChatOutlined,
} from "@assets";

const Appbar = () => {
  const navigate = useNavigate();

  const goToSearch = () => {
    navigate(`/${PUBLIC_ROUTE.SEARCH}`);
  }

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  }

  const goToMessage = () => {
    navigate(`/${PUBLIC_ROUTE.MESSAGE}`);
  }

  return (
    <Bar>
      <Icon onClick={goToMessage}>
        <ChatOutlined />
        <Text>Chat</Text>
      </Icon>

      <LogoWrapper>
        <Logo />
      </LogoWrapper>

      <IconsWrapper>
        <Icon onClick={goToSearch} >
          <SearchOutlined />
        </Icon>

        <Icon onClick={goToDownload}>
          <DownloadOutlined />
        </Icon>
      </IconsWrapper>
    </Bar>
  );
};

export default Appbar;
